import React from "react";
import sfxmanager from "./sfxmanager";


export const sfx = new sfxmanager();
const SocketContext = React.createContext();

export default SocketContext;